export default "__VITE_ASSET__BUIs$_Gp__"